<template>
    <div class="pdetail_tabs_box">
        <!-- 标签页部分 -->
        <div class="pdetail_tabs">
            {{$t("message.pdetail.detail")}}
        </div>
        <!-- 内容区域 -->
        <div class="pdetail_tabs_content">
            <div class="container">
                <template v-if="goods.goods_desc">
                    <div v-html="goods.goods_desc"></div>
                </template>
                <template v-else>
                    <div class="pdetail_tabs_content_nothing">
                        {{$t("message.pdetail.notdetail")}}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: mapState({
        goods: state => state.goods.goods
    }),
}
</script>

<style scoped>
/* 详情描述标签页 */
.pdetail_tabs{
    padding: 20px 0;
    text-align: center;
    color: #ff6700;
    font-size: 18px;
    background: #fff;
    border-top: 1px solid #e0e0e0;
}

.pdetail_tabs_content{
    background: #f5f5f5;
    padding: 30px 0;
}
/* 暂无详情描述 */
.pdetail_tabs_content_nothing{
    text-align: center;
}
</style>
